import { DASH_MEDIDAS_SECTION_ORDER_KEY } from "../pages/DashMedidas/hooks/useDashMedidasSectionOrder";

export const PRESERVED_LOCAL_STORAGE_KEYS = [
  "hasSeenWelcomeModal",
  "sidebarCollapsed",
  DASH_MEDIDAS_SECTION_ORDER_KEY,
];

export const clearLocalStoragePreservingUserPreferences = () => {
  const preserved = PRESERVED_LOCAL_STORAGE_KEYS.reduce((acc, key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});

  localStorage.clear();

  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};
